import { extractErrorCode, extractErrorMessage } from "@/src/utils/errorUtils";
import { BaseCompanyRequestBody, WorkspaceFormData } from "./Workspace.types";

export { extractErrorCode, extractErrorMessage as parseErrorMessage };

export const buildBaseRequestBody = (
  formData: WorkspaceFormData,
  countryName: string,
  countryCodeItemName: string
): BaseCompanyRequestBody => ({
  companyType: "BOTH" as const,
  countryName,
  countryCodeItemName,
  businessNumber: formData.businessNumber,
  companyName: formData.companyName,
  tel: formData.tel,
  telPrefix: formData.telPrefix,
  postalCode: formData.postalCode,
  streetAddress: formData.streetAddress,
  region: formData.region,
  locality: formData.locality,
  city: formData.timezoneCity,
  gmtOffset: formData.timezoneGmtOffset,
  industryCodeItemNames: [],
  mainCategoryCodeItemNames: formData.mainCategoryCodeItemNames,
  faxPrefix: formData.faxPrefix || undefined,
  fax: formData.fax || undefined,
  joinPath: undefined,
  joinPathDescription: undefined,
  autoApproveNewMembers: false,
});

export const validateFormCompletion = (formValues: WorkspaceFormData): boolean => {
  return !!(
    formValues.companyName &&
    formValues.countryCodeItemName &&
    formValues.telPrefix &&
    formValues.tel &&
    formValues.businessNumber &&
    formValues.timezoneCity &&
    formValues.mainCategoryCodeItemNames?.length > 0
  );
};

export const extractCountryInfo = (countryCodeItemName: string) => {
  const parts = countryCodeItemName.split("&");
  return {
    countryCode: parts[0],
    countryPrefix: parts[1] || ""
  };
};